import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { TransactionResponse } from '../../../../app/services/transactionService/transaction'
import { BasicTable } from '../../../components/BasicTable'
import { ColumnDefinitionCustomerTransaction } from '../../Clientes/CustomerTransactionsPage/components/ColumnDefinitionCustomerTransaction'

interface TableTransactionsProps {
  data: TransactionResponse | undefined
  setSkip: (value: number) => void
}
export default function TableTransactions({
  data,
  setSkip,
}: TableTransactionsProps) {
  const getPageIndex = () => {
    if (!data) return 0
    return Math.floor(data.pagination.skip / data.pagination.limit) + 1
  }

  const getPageCount = () => {
    if (!data) return 0
    return Math.ceil(data.pagination.total / data.pagination.limit)
  }

  const handleNextPage = () => {
    if (!data) return
    const newPage = data?.pagination?.skip / data?.pagination?.limit + 1
    if (getPageCount() === getPageIndex()) return
    const skipValue = newPage * data.pagination.limit
    setSkip(skipValue)
  }

  const handlePreviousPage = () => {
    if (!data) return
    const newPage = data?.pagination?.skip / data?.pagination?.limit - 1
    if (newPage < 0) return
    const skipValue = newPage * data.pagination.limit
    setSkip(skipValue)
  }
  const { columnsCustomerTransactions } = ColumnDefinitionCustomerTransaction()

  const table = useReactTable({
    data: data?.transactions || [],
    columns: columnsCustomerTransactions,
    getPaginationRowModel: getPaginationRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  })
  return (
    <div className="mt-8">
      <BasicTable
        getPageCount={getPageCount}
        getPageIndex={getPageIndex}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
        table={table}
        type="only header"
      />
    </div>
  )
}
